import { ca } from '@cian/analytics';

export function trackNewsSubscriptionClick(needSubscribtion: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Profile_user_comm_popup',
    action: 'Click',
    label: `Step_6_${needSubscribtion}`,
  });
}
